module.exports = __webpack_public_path__ + "img/Hero-mobile.d91ad02e.png";